"use client";

import React from 'react';
import { usePathname } from 'next/navigation';
import BkashBackButton from './BkashBackButton';

export default function BkashBackButtonWrapper() {
  const pathname = usePathname();

  // Do not show on home page
  // if (pathname === '/' || pathname === '/404') return null;
  if (!pathname || pathname === "/" || pathname.includes("error")) return null;


  return (
    <BkashBackButton merchantName="A2B NETWORK LIMITED" isProduction={true} /> 
  );
}
